import "esbuild-css-modules-plugin-ns-css:src/js/components/card/card.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/card/card.module.css:injector.js";
export default new Proxy({
  "cardContainer": "card-module__cardContainer_W4cnHG__1100",
  "cardContainerSelected": "card-module__cardContainerSelected_W4cnHG__1100",
  "cardInput": "card-module__cardInput_W4cnHG__1100",
  "cardTitle": "card-module__cardTitle_W4cnHG__1100",
  "descriptionText": "card-module__descriptionText_W4cnHG__1100",
  "iconContainer": "card-module__iconContainer_W4cnHG__1100",
  "titleContainer": "card-module__titleContainer_W4cnHG__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      